"use client";

import { motion } from "framer-motion";

type Value = {
  number: string;
  title: string;
  description: string;
};

export default function Values({
  eyebrow,
  title,
  values,
}: {
  eyebrow: string;
  title: string;
  values: Value[];
}) {
  return (
    <section className="bg-[#0b0b0d] py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl">
          <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 font-body">
            {eyebrow}
          </p>
          <h2 className="mt-6 font-heading text-4xl md:text-5xl leading-[1.1] font-light text-white">
            {title}
          </h2>
        </div>

        {/* Grid */}
        <div className="mt-16 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-2">
          {values.map((value, i) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: "easeOut" }}
              className="group bg-[#0b0b0d] p-10 transition-colors hover:bg-white/[0.02] md:p-14"
            >
              <span className="font-heading text-6xl italic font-light text-white/15 leading-none">
                {value.number}
              </span>

              <h3 className="mt-6 font-heading text-2xl md:text-3xl font-light text-white">
                {value.title}
              </h3>

              <p className="mt-4 text-sm leading-relaxed text-white/55 font-body font-light">
                {value.description}
              </p>

              <span className="mt-8 block h-px w-12 bg-white/20 transition-all duration-500 group-hover:w-24 group-hover:bg-white/40" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
